"use client"

import { NuisibleCreateInput } from '@repo/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NuisibleService } from '../../../lib/api/services/nuisible.service';

const nuisibleService = new NuisibleService();

export function useCreateNuisible() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: NuisibleCreateInput) => nuisibleService.createNuisible(data),
    onSuccess: () => {
      // Invalidate and refetch nuisibles list
      queryClient.invalidateQueries({ queryKey: ['nuisibles'] });
    },
  });
}